<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters()}`+ $t('key1000597')" prop="ymsProductCategoryId">
              <classificationSelect ref="classificationDom" @selectValue="changeValue"></classificationSelect>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003343')" prop="supplierMerchantId">
              <Input :placeholder="$t('key1002842')" v-model.trim="pageParams.supplierMerchantId" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                transfer
                type="datetimerange"
                class="wid100P"
                :options="dateOptions"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="createTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000600')" prop="supplierSpuList">
              <Input type="textarea" :placeholder="$t('key1001094')" v-model.trim="pageParams.supplierSpuList"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" class="mr15" @click="batchAudit"
        v-if="getPermission('ymsProductInfoTemplate_batchApproved')">{{ $t('key1003204') }}</Button>
      <Button type="primary" class="mr15" @click="batchRejection"
        v-if="getPermission('ymsProductInfoTemplate_batchRejected')">{{ $t('key1003450') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="490"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="getSelectValue">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="curPage"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--驳回原因弹窗-->
    <reasonForRejectionModal ref="reasonForRejection" @updateData="pageParamsStatus=true"></reasonForRejectionModal>
    <!--商品售卖国弹窗-->
    <sellingCountrySettingModal ref="sellingCountrySetting" @updateData="toExamineFun"></sellingCountrySettingModal>
    <!--日志弹窗-->
    <productReviewForSaleLogModal ref="productReviewForSaleLog"></productReviewForSaleLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import reasonForRejectionModal from "@/components/common/reasonForRejectionModal.vue";
import classificationSelect from "@/components/common/classificationSelect.vue";
import {
  _handleMultilingualFields, getBatchCategoryInfoData, commonLocalStorage, to1688ByImg,
  getCloudTreeData, getDataSetBatchList, getEnumName, isValueEmpty
} from "@/utils/common";
import sellingCountrySettingModal from "@/components/common/sellingCountrySettingModal.vue";
import productReviewForSaleLogModal from "@/views/yms/components/commodityManage/productReviewForSaleLogModal.vue";
export default {
  name: 'productReviewForSaleList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      createTime: [],
      total: 0,
      curPage: 1,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'primaryImage',
          width: 120,
          align: 'center',
          render(h, params) {
            let platformId = params.row.platformId;
            return v.tableImg(h, params, 'primaryImage', '', () => {
              const {href} = v.$router.resolve({
                path: '/productReviewForSaleDetails',
                query: {
                  type: 'look',
                  productId: params.row.ymsProductId,
                  ymsProductInfoTemplateId: params.row.ymsProductInfoTemplateId,
                  supplierMerchantId: params.row.supplierMerchantId,
                  platformId: platformId,
                  reviewType: 'onSaleReview'
                }
              });
              let link = window.location.href;
              localStorage.setItem('originalPath', link);
              setTimeout(() => {
                window.open(href, '_blank');
              }, 500);
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003441'),
          key: 'supplierMerchantId',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let spu = params.row.supplierSpu;
            let platformId = params.row.platformId;
            return h('Alink', {
              props: {
                linkName: spu,
                className: 'justify-content-center'
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/productReviewForSaleDetails',
                    query: {
                      type: 'look',
                      productId: params.row.ymsProductId,
                      ymsProductInfoTemplateId: params.row.ymsProductInfoTemplateId,
                      supplierMerchantId: params.row.supplierMerchantId,
                      platformId: platformId,
                      reviewType: 'onSaleReview'
                    }
                  });
                  let link = window.location.href;
                  localStorage.setItem('originalPath', link);
                  setTimeout(() => {
                    window.open(href, '_blank');
                  }, 500);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003442'),
          key: 'classificationName',
          width: 250,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003443'),
          key: 'cnName',
          minWidth: 200,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003444'),
          key: 'supplierMerchantIdAndName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            let supplierMerchantId = params.row.supplierMerchantId;
            let supplierMerchantIdAndName = params.row.supplierMerchantIdAndName;
            return h('div', [
              h('span', supplierMerchantId),
              h('p', supplierMerchantIdAndName)
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882'),
          key: 'supplyPrice',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            const {maxSuggestPrice, minSuggestPrice, currency} = params.row;
            let price;
            const hasMax = !isValueEmpty(maxSuggestPrice);
            const hasMin = !isValueEmpty(minSuggestPrice);
            if (hasMax && hasMin) {
              price = maxSuggestPrice === minSuggestPrice ? maxSuggestPrice : `${minSuggestPrice} ~ ${maxSuggestPrice}`;
            } else if (hasMax) {
              price = maxSuggestPrice;
            } else if (hasMin) {
              price = minSuggestPrice;
            } else {
              price = '';
            }
            return h('div', [
              h('p', price || '-'),
              price ? h('p', '(' + (currency || '') + ')') : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003445'),
          key: 'auditStatus',
          minWidth: 110,
          align: 'center',
          render: (h, params) => {
            let auditStatus = params.row.auditStatus;
            let title = getEnumName(v.enumData, 'YmsProductInfoAuditStatusCoreEnum', auditStatus, 'number');
            return h('div', title);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          width: 170,
          align: 'center',
          sortable: true,
          render(h, params) {
            let time = params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 150,
          fixed: 'right',
          align: 'left',
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003340'),
                    show: true,
                    clickFn: () => {
                      to1688ByImg(params.row.primaryImage);
                    },
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['productReviewForSaleLog'].initProductReviewForSaleLogData(params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      pageParams: {
        ymsProductCategoryId: null,
        supplierMerchantId: null,
        supplierSpuList: '',
        updatedStartTime: null,
        updatedEndTime: null,
        type: 2,
        pageNum: 1,
        pageSize: 15
      },
      selectTableData: [],
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsProductInfoAuditStatusCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.getCloudSalesClassification();
      this.search();
    },
    // 获取云卖分类的数据
    getCloudSalesClassification() {
      getCloudTreeData(api.post_ymsProductCategory_queryAll, 'tile').then((data) => {
        this.$nextTick(() => {
          this.$refs['classificationDom'].initClassificationData(data);
        });
      });
    },
    // 分类筛选
    changeValue(value) {
      this.pageParams.ymsProductCategoryId = value;
    },
    // 获取创建时间
    getDateValue(value) { // 获取日期返回值
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.updatedStartTime = null;
          v.pageParams.updatedEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.createTime = v.defaultTimePeriod(value, false);
          v.pageParams.updatedStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.updatedEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置创建时间
    resetDate() {
      this.pageParams.updatedStartTime = null;
      this.pageParams.updatedEndTime = null;
    },
    // 查询按钮
    search() {
      this.curPage = 1;
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let query = JSON.parse(JSON.stringify(v.pageParams));
      if (!v.pageParams.supplierMerchantId) {
        query.supplierMerchantId = null;
      }
      if (v.pageParams.supplierSpuList === '') {
        query.supplierSpuList = [];
      } else {
        query.supplierSpuList = v.sepCommasFn(v.pageParams.supplierSpuList, ['\n']);
      }
      return query;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      if (v.getPermission('ymsProductInfoTemplate_query')) {
        localStorage.removeItem('originalPath');
        v.tableLoading = true;
        v.axios.post(api.post_ymsProductInfoTemplate_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            let ymsProductCategoryIds = [];
            list.map((item) => {
              ymsProductCategoryIds.push(item.ymsProductCategoryId)
            });
            if (ymsProductCategoryIds.length > 0) {
              getBatchCategoryInfoData(api.post_ymsProductCategory_queryByYmsProductCategoryIds, list, ymsProductCategoryIds).then((newData) => {
                v.tableData = newData;
                handleData();
              });
            } else {
              v.tableData = list;
              handleData();
            }

            function handleData() {
              if (v.tableData.length > 0) {
                v.tableData.map((item) => {
                  let text = item.supplierMerchantIdAndName.split('/')[1] || '';
                  item.supplierMerchantIdAndName = _handleMultilingualFields(text);
                  let imgList = item.imagePath ? item.imagePath.split(',') : [];
                  if (imgList.length > 0) {
                    item.primaryImage = imgList[0];
                  } else {
                    item.primaryImage = null;
                  }
                });
                v.$forceUpdate();
              }
              v.updateTableDom('tableDom');
            }

            v.total = data.total;
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.$nextTick(() => {
        v.$refs['classificationDom'].reset();
      })
      v.createTime = [];
      v.resetDate();
      v.getList();
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 批量审核
    batchAudit() {
      if (this.selectTableData.length > 0) {
        let supplierProductIds = [];
        this.selectTableData.map((item) => {
          if (item.supplierProductId) {
            supplierProductIds.push(item.supplierProductId);
          }
        });
        if (this.showProductSaleCountrySet) {
          this.$refs['sellingCountrySetting'].initSellingCountrySettingData('setting', supplierProductIds)
        } else {
          this.toExamineFun();
        }
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003446'));
      }
    },
    // 审核方法
    toExamineFun() {
      let ymsProductInfoTemplateIds = [];
      this.selectTableData.map((item) => {
        if (item.ymsProductInfoTemplateId) {
          ymsProductInfoTemplateIds.push(item.ymsProductInfoTemplateId);
        }
      });
      this.axios.put(api.put_ymsProductInfoTemplate_batchApproved, ymsProductInfoTemplateIds,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003447')}).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003448'));
          this.pageParamsStatus = true;
        }
      });
    },
    // 批量驳回
    batchRejection() {
      if (this.selectTableData.length > 0) {
        let ymsProductInfoTemplateIds = [];
        this.selectTableData.map((item) => {
          ymsProductInfoTemplateIds.push(item.ymsProductInfoTemplateId);
        });
        this.$refs['reasonForRejection'].initReasonForRejectionData(ymsProductInfoTemplateIds, 'onSaleReview');
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003449'));
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    sellingCountrySettingModal,
    classificationSelect,
    reasonForRejectionModal,
    productReviewForSaleLogModal
  }
};
</script>

<style scoped>

</style>
